export enum TemplateMode {
  draft = 1,
  published = 2,
}
